module.exports = __webpack_public_path__ + "img/kids_logo.17ffa306.png";